"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.warehouseInfoUpdateSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const AddressValidator_1 = require("../../shared/validators/AddressValidator");
const ContactInfoValidator_1 = require("../../shared/validators/ContactInfoValidator");
const GenericValidator_1 = __importDefault(require("../../shared/validators/GenericValidator"));
const EditStatus_1 = require("../models/OrgProfile/EditStatus");
const WarehouseCapabilities_1 = require("../models/OrgProfile/WarehouseCapabilities");
const HoursOfOperationValidator_1 = require("./HoursOfOperationValidator");
const StorageDetailsValidator_1 = require("./StorageDetailsValidator");
const _warehouseInfoCapabilities = Object.values(WarehouseCapabilities_1.WarehouseCapabilities);
const _warehouseInfoCertifications = Object.values(WarehouseCapabilities_1.WarehouseCertifications);
const _warehouseInfoBuildingSpecifications = Object.values(WarehouseCapabilities_1.BuildingSpecifications);
const _warehouseInfoTechnologies = Object.values(WarehouseCapabilities_1.WarehouseTechnologies);
const _editStatus = Object.values(EditStatus_1.EditStatus);
exports.warehouseInfoUpdateSchema = joi_1.default.object({
    id: joi_1.default.string().allow('').required(),
    name: joi_1.default.string()
        .max(200)
        .min(1)
        .trim()
        .pattern(/^[\w\d][\s\S]*/)
        .required(),
    editStatus: joi_1.default.string()
        .valid(..._editStatus)
        .default(EditStatus_1.EditStatus.draft),
    description: joi_1.default.string().optional().allow(''),
    address: AddressValidator_1.addressSchema,
    contact: ContactInfoValidator_1.contactInfoSchema,
    videoUrl: joi_1.default.string().optional().allow(''),
    videoDescription: joi_1.default.string().optional().allow(''),
    images: joi_1.default.array().items(joi_1.default.object({
        url: joi_1.default.string().required(),
        caption: joi_1.default.string().optional().allow(''),
    })),
    capabilities: joi_1.default.array().items(joi_1.default.string().valid(..._warehouseInfoCapabilities)),
    hoursOfOperation: HoursOfOperationValidator_1.hoursOfOperationSchema,
    storage: joi_1.default.object({
        rack: joi_1.default.array().items(StorageDetailsValidator_1.storageDetailsSchema),
        bin: joi_1.default.array().items(StorageDetailsValidator_1.storageDetailsSchema),
        buildingDetails: joi_1.default.object({
            warehouseSize: joi_1.default.number(),
            numberOfPallets: joi_1.default.number(),
        }),
    }),
    operations: joi_1.default.object({
        whManagementSystem: joi_1.default.object({
            technology: joi_1.default.string()
                .valid(..._warehouseInfoTechnologies)
                .required(),
            capabilities: joi_1.default.array().items(joi_1.default.string().valid(..._warehouseInfoCapabilities)),
        }),
        buildingSpecifications: joi_1.default.array().items(joi_1.default.string().valid(..._warehouseInfoBuildingSpecifications)),
        docking: joi_1.default.object({
            dockDoors: joi_1.default.number().required(),
            height: joi_1.default.number().required(),
        }),
        certifications: joi_1.default.array().items(joi_1.default.string().valid(..._warehouseInfoCertifications)),
    }),
    hubspotRowId: joi_1.default.string(),
});
class WarehouseInfoUpdateValidator extends GenericValidator_1.default {
    validate(input) {
        super.validate(input, 'IWarehouseInfo', exports.warehouseInfoUpdateSchema);
    }
}
exports.default = WarehouseInfoUpdateValidator;
